import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_ACTIVE_USERS_LIST = 'GET_ACTIVE_USERS_LIST';


export const service = async (data) => {
  const options: object = {
    url:  "/Api/UserTasks/GetAllActiveUsers" ,
    method: "GET",
    contentType: 'application/json'
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ACTIVE_USERS_LIST, service, mock);
